import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-blue-600/20 text-blue-400 border-blue-600/30',
        secondary: 'border-transparent bg-slate-700 text-slate-300',
        destructive: 'border-transparent bg-red-600/20 text-red-400 border-red-600/30',
        outline: 'text-slate-300 border-slate-600',
        success: 'border-transparent bg-emerald-600/20 text-emerald-400 border-emerald-600/30',
        warning: 'border-transparent bg-amber-600/20 text-amber-400 border-amber-600/30',
        purple: 'border-transparent bg-purple-600/20 text-purple-400 border-purple-600/30',
        cyan: 'border-transparent bg-cyan-600/20 text-cyan-400 border-cyan-600/30',
        rose: 'border-transparent bg-rose-600/20 text-rose-400 border-rose-600/30',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
